import React from 'react';
import connectField    from 'uniforms/connectField';
import {createElement} from 'react';

import formatFieldToString from './formatFieldToString';

const ReadOnlyMiddle = (props) => {
    return(
        <div className={'form-bg-light-grey-nr'} style={{paddingBottom: 0, paddingTop: 0}}>
            <div className={'form-bg-dark-grey'} style={{borderRadius: 0, marginBottom: 0, marginTop: 0, paddingBottom: 3, paddingTop: 3}}>
                <b>{props.label}</b>: {formatFieldToString(props)}
            </div>
        </div>
    );
}

ReadOnlyMiddle.defaultProps = {
    tag: 'div'
};

export default connectField(ReadOnlyMiddle);
